import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ConvertListingStep from './steps/convert-listing-step';
import FileConfirmationSetup from './steps/file-confirmation-email';
import CongratsEmail from './steps/congrats-email';
import CongratsEmailListingGonePending from './steps/congrats-email-listing-gone-pending';
import CongratsEmailSale from './steps/congrats-email-sale';
import ConfirmReadNotesStep from './steps/confirm-read-notes-step';
import TimelineWorkflowStep from './steps/timeline/timeline-workflow-step';
import SendIntroSeller from './steps/send-intro-seller.js';
import FileConfirmationListingGonePendingEmail from './steps/file-confirmation-listing-gone-pending-email';
import IntroEmailEscrowTitle from './steps/intro-email-escrow-title';
import ClientIntroductionCoopAgentEmailListingGonePending from './steps/client-introduction-co-op-agent-email-listing-gone-pending';
import CreateInvoiceStep from './steps/create-invoice-step';
import SendInvoice from './steps/send-invoice';
import FileConfirmationSetupSale from './steps/file-confirmation-sale';
import SendIntroBuyerEmail from './steps/send-intro-buyer';
import IntroductionCoopAgentSaleEmail from './steps/introduction-co-op-agent-sale-email';
import SendConfirmationFileSetupAgentDoubleEnded from './steps/send-confirmation-file-setup-agent-double-ended';

@inject('appStore')
@observer
export default class InitiationWorkflow extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const accordionId = 'initiation-workflow-accordion';
        const deadline = this.props.appStore.tcFileStore.selectedFile.createdOn;
        const hasCancelButton = true

        const renderSteps = () => {
            const steps = this.props.appStore.workflowStore.workflow
                .map((step) => {
                    switch (step.type) {
                        case 'congrats-email':
                            return (
                                <CongratsEmail
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        case 'congrats-email-listing-gone-pending':
                            return (
                                <CongratsEmailListingGonePending
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        case 'congrats-email-sale':
                            return (
                                <CongratsEmailSale
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        case 'convert-listing':
                            return (
                                <ConvertListingStep
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                />
                            );
                        case 'file-setup-email':
                            return (
                                <FileConfirmationSetup
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        case 'confirm-read':
                            return (
                                <ConfirmReadNotesStep
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                />
                            );
                        case 'calendar':
                            return (
                                <TimelineWorkflowStep
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                />
                            );
                        case 'introduction-seller-email':
                            return (
                                <SendIntroSeller
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        case 'file-setup-email-listing-gone-pending':
                            return (
                                <FileConfirmationListingGonePendingEmail
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        case 'intro-email-escrow-title':
                            return (
                                <IntroEmailEscrowTitle
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={hasCancelButton}
                                />
                            );
                        case 'client-introduction-co-op-agent-email-listing-gone-pending':
                            return (
                                <ClientIntroductionCoopAgentEmailListingGonePending
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        case 'create-invoice':
                            return (
                                <CreateInvoiceStep
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                />
                            );
                        case 'send-invoice':
                            return (
                                <SendInvoice
                                    key={step.stepId}
                                    step={step}
                                    invoiceStepState={this.props.appStore.workflowStore.invoiceStepState}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={hasCancelButton}
                                />
                            );
                        case 'file-setup-email-sale':
                            return (
                                <FileConfirmationSetupSale
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        case 'introduction-buyer-email':
                            return (
                                <SendIntroBuyerEmail
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        case 'introduction-co-op-agent-sale-email':
                            return (
                                <IntroductionCoopAgentSaleEmail
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        case 'file-setup-email-double-ended':
                            return (
                                <SendConfirmationFileSetupAgentDoubleEnded
                                    key={step.stepId}
                                    step={step}
                                    accordionId={accordionId}
                                    deadlineCalculated={deadline}
                                    hasCancelHandler={!hasCancelButton}
                                />
                            );
                        default:
                            return null;
                    }
                })
                .filter((step) => step); //filter out 'undefined' entries

            return steps;
        };

        return (
            <div className="panel-group initiation-workflow" id={accordionId}>
                {renderSteps()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/initiation-workflow.js